var map = {
	"./Harry's Wand - Img - Final (2)_00.jpg": 2215,
	"./Harry's Wand - Img - Final (2)_01.jpg": 2216,
	"./Harry's Wand - Img - Final (2)_02.jpg": 2217,
	"./Harry's Wand - Img - Final (2)_03.jpg": 2218,
	"./Harry's Wand - Img - Final (2)_04.jpg": 2219,
	"./Harry's Wand - Img - Final (2)_05.jpg": 2220,
	"./gallery_00.jpg": 2221,
	"./gallery_01.jpg": 2222,
	"./gallery_02.jpg": 2223,
	"./gallery_03.jpg": 2224,
	"./gallery_04.jpg": 2225,
	"./gallery_05.jpg": 2226
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2214;